import { trackSwitchPlanType } from '@ecomm/cdp-tracking'
import { isSmbMVP } from '@ecomm/data-env-variables'
import { useLocation } from '@ecomm/framework/useLocation'
import { useNavigate } from '@ecomm/framework/useNavigate'
import { useTranslation } from '@ecomm/i18n'
import { localStorage } from '@simplisafe/ewok'
import { useCallback, useMemo } from 'react'
import { monitoringOptions } from '../types'

type Props = {
  readonly isBusiness: boolean
}

export function ChangeBusinessUnit({ isBusiness }: Props) {
  const { t } = useTranslation('maps')
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const monitoringChoice = pathname.includes('choose')
    ? 'choose-monitoring'
    : 'change-monitoring'

  const isVisible = useMemo(() => {
    return monitoringOptions.some(o => pathname.includes(o)) && isSmbMVP
  }, [pathname])

  const changeBusinessUnit = useCallback(() => {
    trackSwitchPlanType(isBusiness ? 'home' : 'business')
    navigate(
      isBusiness ? `/${monitoringChoice}` : `/business/${monitoringChoice}`
    )
  }, [isBusiness, monitoringChoice, navigate])

  const isFromBusinessPackage =
    localStorage.get('fromBusinessPackage') === 'true'

  return isVisible && !isFromBusinessPackage ? (
    <div
      className="flex flex-col md:flex-row mb-4 items-center justify-center"
      data-testid="ChangeBusinessUnit"
    >
      <span className="font-bold mx-2">
        {t(
          `${monitoringChoice}.${isBusiness ? 'business' : 'residential'}.switch-business-unit-msg`
        )}
      </span>
      <button
        className="border-none bg-transparent text-primary cursor-pointer p-0 outline-none text-lg hover:underline text-complementary-blue-100"
        onClick={changeBusinessUnit}
      >
        {t(
          `${monitoringChoice}.${isBusiness ? 'business' : 'residential'}.switch-business-unit-link`
        )}
      </button>
    </div>
  ) : null
}
